// some store ids have spaces in them. replace them with %20
export function replaceSpace(string) {
  return string.replace(' ', '%20')
}
